/**
 * Template Master
 *
 *
 *
 *
 */

import React from 'react';

import Model from './models';

import { ApiUtils, BaseAPI } from 'soxo-bootstrap-core';

class DocFileType extends BaseAPI {
    get id() {
        return 'docft_id';
    }

    get getEndpoint() {
        return 'doc-file-types';
    }

    get path() {
        return `doc-file-types`;
    }

    get getName() {
        return this.modelName;
    }

    get modelName() {
        return `DocFileTypes`;
    }
}

export default DocFileType;
